<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { useFormatDateTime, useFormModel } from "@/hooks";
import { computed, ref } from "vue";
import type { InputAlign } from "@nutui/nutui";

const props = defineProps<{
  modelValue?: string | Date;
  type?: string;
  dateFormat: string;
  placeholder?: string;
  inputAlign?: InputAlign;
}>();

const emit = defineEmits(["update:modelValue", "change"]);

const show = ref(false);
const currentDate = ref(new Date());

const { formatted } = useFormatDateTime(
  computed(() => props.modelValue),
  props.dateFormat
);

function confirm({ selectedValue }: any) {
  show.value = false;
  const date =
    props.type === "datetime"
      ? new Date(
          selectedValue[0],
          selectedValue[1] - 1,
          selectedValue[2],
          selectedValue[3],
          selectedValue[4]
        )
      : new Date(selectedValue[0], selectedValue[1] - 1, selectedValue[2]);

  emit("update:modelValue", date);
  emit("change", date);
}

const { setFormModel } = useFormModel();
defineExpose({ setFormModel });
</script>
<template>
  <div class="mp-date-picker">
    <nut-input
      :model-value="formatted"
      :placeholder="placeholder"
      :input-align="inputAlign"
      :border="false"
      readonly
      type="text"
      @click="show = true"
    />
    <nut-popup position="bottom" v-model:visible="show">
      <nut-date-picker
        v-model="currentDate"
        v-bind="$attrs"
        :type="type"
        @confirm="confirm"
        @cancel="show = false"
      >
      </nut-date-picker>
    </nut-popup>
  </div>
</template>
<style lang="scss">
.mp-date-picker {
  width: 100%;
}
</style>
